import { render, staticRenderFns } from "./ActionItem.vue?vue&type=template&id=3a1f538b&scoped=true&"
import script from "./ActionItem.vue?vue&type=script&lang=js&"
export * from "./ActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f538b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1f538b')) {
      api.createRecord('3a1f538b', component.options)
    } else {
      api.reload('3a1f538b', component.options)
    }
    module.hot.accept("./ActionItem.vue?vue&type=template&id=3a1f538b&scoped=true&", function () {
      api.rerender('3a1f538b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Actions/ActionItem.vue"
export default component.exports